export default __webpack_public_path__ + "static/media/1.90a8f645.png";